import { render, staticRenderFns } from "./AtlasSuggestionReview.vue?vue&type=template&id=3f53bd4a&scoped=true"
import script from "./AtlasSuggestionReview.vue?vue&type=script&lang=js"
export * from "./AtlasSuggestionReview.vue?vue&type=script&lang=js"
import style0 from "./AtlasSuggestionReview.vue?vue&type=style&index=0&id=3f53bd4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f53bd4a",
  null
  
)

export default component.exports